import { render, staticRenderFns } from "./SubmissionInsuredDataList.vue?vue&type=template&id=3c075fa8"
import script from "./SubmissionInsuredDataList.vue?vue&type=script&lang=js"
export * from "./SubmissionInsuredDataList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports